import Index from '@/views/auth/Index.vue';
import SignIn from '@/views/auth/SignIn.vue';
import SignUp from '@/views/auth/SignUp.vue';
import Reset from '@/views/auth/Reset.vue';
import Register from '@/views/auth/Register.vue';
// import Confirm from '@/views/auth/Confirm.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: '/auth',
    component: Index,
    children: [
      {
        name: 'auth-reset',
        path: 'reset',
        component: Reset,
        meta: {
          title: 'パスワードのリセット',
          actor: actors.none,
          auth: auths.noRequired,
        },
      },
      {
        name: 'auth-register',
        path: 'register',
        component: Register,
        meta: {
          title: 'ユーザ情報の登録',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
      {
        name: 'auth-signup',
        path: 'signup',
        component: SignUp,
        meta: {
          title: 'サインアップ',
          actor: actors.none,
          auth: auths.noRequired,
        },
      },
      {
        name: 'auth-signin',
        path: 'signin',
        component: SignIn,
        meta: {
          title: 'サインイン',
          actor: actors.none,
          auth: auths.noRequired,
        },
      },
      // {
      //   name: 'auth-confirm',
      //   path: 'confirm',
      //   component: Confirm,
      //   meta: {
      //     title: '確認コードの確認',
      //     actor: actors.none,
      //     auth: auths.noRequired,
      //   },
      // },
    ],
  },
];

export default {
  routes,
};
